import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D6AFEFE4-0E22-4197-B094-53E9528FFF0A
 * name arrow-top-left-bottom-right-bold
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-left-bottom-right-bold.svg
 * tags
 * - Arrow 
 */
export const ArrowTopLeftBottomRightBoldIcon = createSvgIcon(<><path d="M5.83,8.66L3,11.5V3H11.5L8.66,5.83L18.17,15.34L21,12.5V21H12.5L15.34,18.17L5.83,8.66Z" /></>, 'ArrowTopLeftBottomRightBoldIcon');
export default ArrowTopLeftBottomRightBoldIcon